module.exports = __webpack_public_path__ + "img/prof7.c8326f1c.jpg";